import { c as _c } from "react/compiler-runtime";
import { IcoPencil16 } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import IdBadge from '../id-badge';
type MetaUpdateVaultCallProps = {
  input: Record<string, unknown>;
  toolResult?: string;
  /** Suppress the leading icon when rendered on a tool-call timeline rail (the rail owns it). */
  hideIcon?: boolean;
};

/** Renders an `update_entity_vault` call as two lines: the action + entity id on the first, and
 * the changed fields as a wrapping paragraph on the second. The generic tool row put the fields
 * inline after the id badge, where a long list overflowed the panel and orphaned the separator. */
const MetaUpdateVaultCall = t0 => {
  const $ = _c(29);
  const {
    input,
    toolResult,
    hideIcon
  } = t0;
  const fpId = input.fp_id as string ?? "";
  const data = input.data as Record<string, unknown> | undefined;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== data || $[1] !== fpId || $[2] !== hideIcon || $[3] !== toolResult) {
    const fields = data ? Object.keys(data).sort() : [];
    const inProgress = !toolResult;
    t4 = "flex items-start gap-1.5 text-caption-1 text-tertiary";
    if ($[9] !== hideIcon) {
      t5 = !hideIcon && <span className="shrink-0 flex items-center h-[1.25em]"><IcoPencil16 /></span>;
      $[9] = hideIcon;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t1 = "flex flex-col gap-1 min-w-0";
    const t6 = inProgress && "text-shimmer";
    let t7;
    if ($[11] !== t6) {
      t7 = cx("text-secondary", t6);
      $[11] = t6;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    const t8 = inProgress ? "Updating vault" : "Updated vault";
    let t9;
    if ($[13] !== t7 || $[14] !== t8) {
      t9 = <span className={t7}>{t8}</span>;
      $[13] = t7;
      $[14] = t8;
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    let t10;
    if ($[16] !== fpId) {
      t10 = fpId && <IdBadge id={fpId} size="compact" />;
      $[16] = fpId;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    if ($[18] !== t10 || $[19] !== t9) {
      t2 = <span className="inline-flex items-center gap-1 flex-wrap">{t9}{t10}</span>;
      $[18] = t10;
      $[19] = t9;
      $[20] = t2;
    } else {
      t2 = $[20];
    }
    t3 = fields.length > 0 && <span className="pl-2 break-words">{fields.join(", ")}</span>;
    $[0] = data;
    $[1] = fpId;
    $[2] = hideIcon;
    $[3] = toolResult;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[21] !== t1 || $[22] !== t2 || $[23] !== t3) {
    t6 = <div className={t1}>{t2}{t3}</div>;
    $[21] = t1;
    $[22] = t2;
    $[23] = t3;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== t4 || $[26] !== t5 || $[27] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  return t7;
};
export default MetaUpdateVaultCall;